import { all } from 'redux-saga/effects'
import kioskSaga2 from './kiosk/saga';

export default function* rootSaga() {
    yield all([
        kioskSaga2()
    ])
}